import MediaImage from '@src/components/MediaImage';
import { CtaFragment, MediaImageFragment } from '@src/graphql/gql-types';
import { getCTA } from '@src/utils/url';
import React from 'react';
import styles from './Tile.module.scss';
import LinkWrapper from '@src/components/LinkWrapper';
import BoxIcon from '@src/elements/BoxIcon';
import classNames from 'classnames';

interface Tile {
  heading: string;
  description: string;
  image: MediaImageFragment;
  primaryCta: CtaFragment | null | undefined;
  option: number;
  profileLayout?: boolean;
}

const TileContent: React.FC<Tile> = ({
  heading,
  description,
  image,
  primaryCta,
  option,
  profileLayout
}) => (
  <>
    {image && (
      <div
        className={classNames(styles.imgWrapper, {
          [styles.imgWrapperProfile]: profileLayout
        })}
      >
        <MediaImage {...image} />
      </div>
    )}
    <div
      className={classNames(styles.tileContent, {
        [styles.tileContentProfile]: profileLayout
      })}
    >
      <div className={styles.tileContentInner}>
        {!!option && (
          <div className={styles.option}>
            <p>Option {option}</p>
          </div>
        )}
        <p className={styles.tileHeading}>{heading}</p>

        {description && (
          <p
            className={classNames(styles.description, {
              [styles.descriptionProfile]: profileLayout
            })}
          >
            {description}
          </p>
        )}
      </div>

      {primaryCta && (
        <div className={styles.contentCta}>
          {primaryCta.label}
          <BoxIcon name="right-arrow-alt" />
        </div>
      )}
    </div>
  </>
);

const Tile: React.FC<Tile> = ({
  heading,
  description,
  image,
  primaryCta,
  option,
  profileLayout
}) => (
  <div
    className={classNames(styles.tile, {
      [styles.tileProfile]: profileLayout
    })}
  >
    {primaryCta ? (
      <LinkWrapper {...getCTA(primaryCta)}>
        <TileContent
          heading={heading}
          description={description}
          image={image}
          primaryCta={primaryCta}
          option={option}
          profileLayout={profileLayout}
        />
      </LinkWrapper>
    ) : (
      <TileContent
        heading={heading}
        description={description}
        image={image}
        option={option}
        primaryCta={undefined}
        profileLayout={profileLayout}
      />
    )}
  </div>
);

export default Tile;
